import {useBooleanFeatureFlag} from "ub-feature-flagging-react";

export function useIsFeatureEnabledBoolean(feature: string) {
    return useBooleanFeatureFlag(feature, false);
}
